<template>
  <div class="accountants-topbar">
    <div class="accountants-topbar--breadcrumbs">
      <CommunicationComposeModal
        v-if="showComposeModal && customerDataLoaded"
        @close="showComposeModal = false"
        :preset-recipient="controlPanelCustomer"
      />

      <router-link
        v-if="isControlPanel && customerDataLoaded"
        :to="{ name: 'ControlPanelSummary', params: { customer_id: $route.params['customerId'] } }"
        class="fullname breadcrumb-link"
      >
        <b-avatar
          class="accountants-topbar--breadcrumbs__avatar avatar"
          :src="controlPanelCustomerCompany.logo ? controlPanelCustomerCompany.logo : ''"
          :text="$gettext('No logo')"
          size="26px"
        />
        {{ controlPanelCustomer.name }}
        <span class="bsn">{{ controlPanelCustomerProfile.bsn ? `— BSN ${controlPanelCustomerProfile.bsn}` : '' }}</span>
      </router-link>
      <b-dropdown
        ref="customerDropdown"
        no-flip
        :text="'something'"
        variant="link"
        block
        class="filterbar-item-button"
        toggle-class="button-no-shadows text-decoration-none text-blue"
        v-b-tooltip.hover.top="{ title: $gettext('Switch customer') }"
        data-analytics-click="topbar switch customer"
      >
        <template #button-content>
          <font-awesome-icon icon="fa-solid fa-users" style="margin: 0" />
        </template>
        <!-- <CustomerSelector
          :exclude-ids="[parseInt($route.params.customerId, 10)]"
          :style-options="{ size: 'sm', height: '300px', width: '225px' }"
          @customer-selected="onSwitchCustomer"
          @customer-selected-multiple="onCustomerSelectedMultiple"
        /> -->
        <CustomerSelector
          :exclude-ids="[parseInt($route.params.customerId, 10)]"
          show-logo
          show-email
          with-search
          :style-options="{ size: 'md', height: '300px', width: '300px' }"
          @customer-selected="onSwitchCustomer"
          @customer-selected-multiple="onCustomerSelectedMultiple"
        />
      </b-dropdown>
    </div>
    <div v-if="isControlPanel" class="accountants-topbar--actions">
      <GekkoButton
        :text="$gettext('See account')"
        icon="fa-regular fa-eye"
        class="text-black-semi"
        @click="openSeeAccount()"
        size="sm"
        variant="light-square"
        data-analytics-click="topbar see account"
      />
      <GekkoButton
        :text="$gettext('Send message')"
        icon="fa-regular fa-comment"
        class="text-black-semi"
        @click="openCommunicationModal()"
        size="sm"
        variant="light-square"
        data-analytics-click="topbar send message"
      />
      <b-dropdown
        right
        class="ui-dashboard-menu-dropdown accountants-topbar-menu-dropdown"
        toggle-class="widget-dropdown-toggle btn-light-square"
        ref="widget-main-dropdown"
        id="widget-main-dropdown"
      >
        <template #button-content>
          <font-awesome-icon icon="fa-solid fa-ellipsis" class="m-0" />
        </template>
        <!-- <DropdownItemDelete
          v-if="isControlPanel && customerDataLoaded"
          :item="{ id: controlPanelCustomer.id }"
          :item-type="'accountant_connection'"
          :item-name="controlPanelCustomer.name"
          @item-deleted="onDisconnected"
        /> -->
        <!-- <b-dropdown-divider /> -->
        <b-dropdown-item @click="$emit('refresh-page', false)">
          <font-awesome-icon icon="fa-solid fa-rotate-right" />
          <span>{{ $gettext('Refresh data') }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import GekkoButton from '@/components/GekkoButton'
import GkLogo from '@/components/ui/GkLogo.vue'
import DropdownItemDelete from '@/components/ui/DropdownItemDelete'
import CustomerSelector from '@/components/accountants/CustomerSelector'
import CommunicationComposeModal from '@/components/accountants/communication/compose/CommunicationComposeModal.vue'

export default {
  name: 'AccountantsTopbar',
  components: {
    GekkoButton,
    GkLogo,
    DropdownItemDelete,
    CustomerSelector,
    CommunicationComposeModal,
  },
  data() {
    return {
      showComposeModal: false,
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
      controlPanelCustomer: 'accountants/getControlPanelCustomer',
      controlPanelCustomerProfile: 'accountants/getControlPanelCustomerProfile',
      controlPanelCustomerCompany: 'accountants/getControlPanelCustomerCompany',
      preferredLanguage: 'main/getPreferredLanguage',
    }),
    currentPage() {
      return this.$route.path
    },
    isControlPanel() {
      return this.currentPage.includes('control-panel')
    },
    customerDataLoaded() {
      return (
        this.controlPanelCustomerCompany &&
        this.controlPanelCustomerProfile &&
        this.controlPanelCustomer &&
        this.controlPanelCustomer.name
      )
    },
  },
  methods: {
    ...mapActions({
      disconnectCustomer: 'accountants/disconnectCustomer',
    }),
    openSeeAccount() {
      window.location.href = '/' + this.preferredLanguage + '/dashboard?vc_id=' + this.$route.params['customerId']
    },
    openCommunicationModal() {
      this.showComposeModal = true
    },
    onDisconnected() {
      this.$emit('customer-disconnected', false)
    },
    onSwitchCustomer(customer) {
      this.$refs.customerDropdown.hide()
      this.$router.push({ name: 'ControlPanelSummary', params: { customerId: customer.customer.id } })
    },
    onCustomerSelectedMultiple(customers) {
      this.$refs.customerDropdown.hide()
      console.log('onCustomerSelectedMultiple', customers)
    },
  },
}
</script>

<style lang="scss">
.accountants-topbar {
  padding: 0.75rem 1rem;
  display: flex;
  align-content: center;
  // background: white;
  justify-content: space-between;
  background: var(--topbar-background-color);
  border-bottom: 1px solid $colorBorderDash;
  height: var(--top-menu-size);
  max-height: var(--top-menu-size);
  .accountants-topbar--breadcrumbs {
    display: flex;
    align-items: center;
    font-size: 24px;
    &__gklogo {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-right: 1rem;
      margin-right: 1rem;
      border-right: 1px solid #d7d7d7;
      svg {
        height: 28px;
      }
      span {
        font-size: 12px;
        line-height: 1;
      }
    }
    &__avatar {
      width: 26px;
      height: 26px;
      margin: 0 5px;
    }
    .breadcrumb-text-base,
    .breadcrumb-separator {
      color: #808080bd;
    }
    .breadcrumb-link {
      &:hover {
        text-decoration: none;
      }
    }
    .breadcrumb-separator {
      padding: 0 0.25rem;
    }
    .fullname {
      font-family: $fontMedium;
      display: flex;
      align-items: center;
      padding-right: 1rem;
      .bsn {
        font-size: 14px;
        color: #00000057;
        font-family: $fontRegular;
      }
    }
    a.fullname {
      color: black;
    }
    &:not(:last-child) {
      .fullname {
        border-right: 1px solid #d7d7d7;
      }
    }
  }

  &--actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .main-company-actions {
  }

  .ui-dashboard-menu-dropdown.accountants-topbar-menu-dropdown {
    width: 30px;
    height: 30px;
    background: transparent;
    cursor: pointer;
    color: $colorTextBase;
    border-radius: calc(#{$gridBorderRadius} / 2);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 20px;
    }
    z-index: 100;
    &:hover {
      color: $colorBrand;
      background: #e8f7f3;
    }
    .widget-dropdown-toggle {
      background: none;
      padding: 0;
      border: 0;
      color: black;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      border-radius: calc(#{$gridBorderRadius} / 2);
      // outline: 1px solid $colorBorderDash;
      &:hover,
      &:active {
        background: #e8f7f3 !important;
        color: $colorTextBase !important;
      }
      &:after {
        display: none;
      }
    }
    &.show {
      z-index: 1000;
      .widget-dropdown-toggle {
        color: $colorBrand;
        background: #e8f7f3;
        border: none;
      }
    }
  }
}
</style>